// Document checklists organized by procedure. Each procedure has a key, FR & AR titles,
// a category (for filtering), and an items list in both languages.

export const DOCUMENT_CATEGORIES = [
  { key: "all", fr: "Toutes les catégories", ar: "جميع الفئات" },
  { key: "immobilier", fr: "Immobilier", ar: "العقارات" },
  { key: "successions", fr: "Successions", ar: "المواريث" },
  { key: "procurations", fr: "Procurations & Actes", ar: "الوكالات والعقود" },
  { key: "societes", fr: "Sociétés & Commerce", ar: "الشركات والتجارة" },
  { key: "garanties", fr: "Garanties & Sûretés", ar: "الضمانات والرهون" },
  { key: "certifications", fr: "Certifications", ar: "الشهادات" },
];

export const DOCUMENTS = [
  {
    key: "vente-immobiliere",
    category: "immobilier",
    fr: {
      title: "Vente immobilière (acte de vente)",
      short: "Acte de vente, promesse de vente, vente sur plan.",
      items: [
        "Pièce d'identité du vendeur et de l'acheteur",
        "Acte de propriété original",
        "Livret foncier ou titre de propriété enregistré",
        "Certificat négatif d'hypothèque récent",
        "Permis de construire et plan approuvé (si applicable)",
        "Quittance de taxe foncière de l'année en cours",
        "Attestation d'assurance (si applicable)",
        "Certificat de conformité du bien",
      ],
    },
    ar: {
      title: "البيع العقاري (عقد البيع)",
      short: "عقد البيع، الوعد بالبيع، البيع على التصاميم.",
      items: [
        "بطاقة الهوية للبائع والمشتري",
        "عقد الملكية الأصلي",
        "الدفتر العقاري أو سند الملكية المسجل",
        "شهادة سلبية للرهن حديثة",
        "رخصة البناء والمخطط المصادق عليه (عند الاقتضاء)",
        "إيصال الرسم العقاري للسنة الجارية",
        "شهادة تأمين (إن وجدت)",
        "شهادة مطابقة العقار",
      ],
    },
  },
  {
    key: "promesse-vente",
    category: "immobilier",
    fr: {
      title: "Promesse de vente / vente sur plan",
      short: "Engagement préalable à la vente définitive.",
      items: [
        "Pièces d'identité des parties",
        "Titre de propriété ou document équivalent",
        "Plan du bien",
        "Permis de construire (pour la vente sur plan)",
        "Accords financiers écrits (modalités de paiement)",
      ],
    },
    ar: {
      title: "الوعد بالبيع / البيع على التصاميم",
      short: "التزام مسبق قبل البيع النهائي.",
      items: [
        "بطاقات هوية الأطراف",
        "سند الملكية أو ما يعادله",
        "مخطط العقار",
        "رخصة البناء (للبيع على التصاميم)",
        "اتفاقيات مالية مكتوبة (طرق الدفع)",
      ],
    },
  },
  {
    key: "donation",
    category: "immobilier",
    fr: {
      title: "Donation",
      short: "Transfert gratuit d'un bien immobilier ou mobilier.",
      items: [
        "Pièces d'identité du donateur et du donataire",
        "Acte de propriété",
        "Acte de naissance du donataire (si lien familial)",
        "Livret de famille",
      ],
    },
    ar: {
      title: "الهبة",
      short: "التنازل المجاني عن مال عقاري أو منقول.",
      items: [
        "بطاقات هوية الواهب والموهوب له",
        "عقد الملكية",
        "شهادة ميلاد الموهوب له (في حال القرابة)",
        "دفتر العائلة",
      ],
    },
  },
  {
    key: "desistement",
    category: "immobilier",
    fr: {
      title: "Désistement / renonciation",
      short: "Renoncer à un droit ou à un bien.",
      items: [
        "Pièce d'identité du renonçant",
        "Acte attestant du droit concerné",
        "Document original à annuler ou modifier",
      ],
    },
    ar: {
      title: "التنازل",
      short: "التخلي عن حق أو عن مال.",
      items: [
        "بطاقة هوية المتنازل",
        "العقد المثبت للحق المعني",
        "الوثيقة الأصلية المراد إلغاؤها أو تعديلها",
      ],
    },
  },
  {
    key: "attestation-notariale",
    category: "immobilier",
    fr: {
      title: "Attestations notariales",
      short: "Attestation d'existence d'acte, de propriété, etc.",
      items: [
        "Pièce d'identité",
        "Document à certifier ou référence de l'acte",
        "Justificatif du motif de la demande",
      ],
    },
    ar: {
      title: "الشهادات الموثقة",
      short: "شهادة وجود عقد، ملكية، إلخ.",
      items: [
        "بطاقة الهوية",
        "الوثيقة المراد تصديقها أو مرجع العقد",
        "ما يبرر سبب الطلب",
      ],
    },
  },
  {
    key: "succession",
    category: "successions",
    fr: {
      title: "Succession / partage / fridha",
      short: "Règlement d'une succession et partage entre héritiers.",
      items: [
        "Acte de décès",
        "Livret de famille du défunt",
        "Pièces d'identité des héritiers",
        "Actes de naissance des héritiers",
        "Actes de propriété des biens à partager",
        "Relevés bancaires (si applicable)",
        "Fridha si déjà établie",
      ],
    },
    ar: {
      title: "الميراث / القسمة / الفريضة",
      short: "تسوية الميراث والقسمة بين الورثة.",
      items: [
        "شهادة الوفاة",
        "دفتر عائلة المتوفى",
        "بطاقات هوية الورثة",
        "شهادات ميلاد الورثة",
        "عقود ملكية الأموال المراد قسمتها",
        "كشوف بنكية (إن وجدت)",
        "الفريضة إن كانت محررة",
      ],
    },
  },
  {
    key: "procuration",
    category: "procurations",
    fr: {
      title: "Procuration",
      short: "Mandat donné à un tiers pour agir en votre nom.",
      items: [
        "Pièces d'identité du mandant et du mandataire",
        "Objet précis de la procuration",
        "Documents liés à la mission confiée (acte, bien, etc.)",
      ],
    },
    ar: {
      title: "الوكالة",
      short: "توكيل شخص آخر للتصرف باسمكم.",
      items: [
        "بطاقات هوية الموكل والوكيل",
        "موضوع الوكالة بدقة",
        "الوثائق المتعلقة بالمهمة (عقد، ملك، إلخ)",
      ],
    },
  },
  {
    key: "reconnaissance-dette",
    category: "procurations",
    fr: {
      title: "Reconnaissance de dette / dépôt / acquittement",
      short: "Actes personnels de reconnaissance, dépôt ou libération.",
      items: [
        "Pièces d'identité des parties",
        "Montant et conditions (échéance, modalités)",
        "Tout justificatif du lien (virement, facture, etc.)",
      ],
    },
    ar: {
      title: "الاعتراف بالدين / الإيداع / الإبراء",
      short: "عقود شخصية للاعتراف، الإيداع أو الإبراء.",
      items: [
        "بطاقات هوية الأطراف",
        "المبلغ والشروط (الأجل، الطريقة)",
        "ما يثبت العلاقة (تحويل، فاتورة، إلخ)",
      ],
    },
  },
  {
    key: "contrat-divers",
    category: "procurations",
    fr: {
      title: "Contrats divers",
      short: "Engagements contractuels à formaliser devant notaire.",
      items: [
        "Pièces d'identité des parties",
        "Objet du contrat (description détaillée)",
        "Conditions financières et calendrier",
        "Tout document annexe (plan, devis, etc.)",
      ],
    },
    ar: {
      title: "عقود متنوعة",
      short: "التزامات تعاقدية تُبرم أمام الموثق.",
      items: [
        "بطاقات هوية الأطراف",
        "موضوع العقد (وصف مفصل)",
        "الشروط المالية والرزنامة",
        "كل وثيقة ملحقة (مخطط، فاتورة تقديرية، إلخ)",
      ],
    },
  },
  {
    key: "creation-societe",
    category: "societes",
    fr: {
      title: "Création de société",
      short: "Constitution d'une société (SARL, EURL, SPA...).",
      items: [
        "Pièces d'identité des associés",
        "Projet de statuts",
        "Justificatif du siège social (contrat de location, acte de propriété)",
        "Dénomination sociale réservée (CNRC)",
        "Attestation de dépôt du capital (si applicable)",
      ],
    },
    ar: {
      title: "تأسيس شركة",
      short: "تأسيس شركة (ذ.م.م، مؤسسة فردية، ش.م.أ...).",
      items: [
        "بطاقات هوية الشركاء",
        "مشروع القانون الأساسي",
        "ما يثبت المقر الاجتماعي (عقد إيجار، عقد ملكية)",
        "التسمية الاجتماعية المحجوزة (CNRC)",
        "شهادة إيداع الرأس مال (إن وجدت)",
      ],
    },
  },
  {
    key: "modification-societe",
    category: "societes",
    fr: {
      title: "Modification de société",
      short: "Changement d'objet, de siège, de gérance, de capital, etc.",
      items: [
        "Statuts en vigueur",
        "Procès-verbal d'assemblée décidant la modification",
        "Pièces d'identité des associés",
        "Justificatifs liés à la modification (nouveau siège, apport, etc.)",
      ],
    },
    ar: {
      title: "تعديل شركة",
      short: "تغيير الغرض، المقر، الإدارة، رأس المال، إلخ.",
      items: [
        "القانون الأساسي الساري",
        "محضر الجمعية الذي يقرر التعديل",
        "بطاقات هوية الشركاء",
        "ما يثبت التعديل (مقر جديد، مساهمة، إلخ)",
      ],
    },
  },
  {
    key: "dissolution-societe",
    category: "societes",
    fr: {
      title: "Dissolution de société",
      short: "Clôture et radiation d'une société.",
      items: [
        "Statuts en vigueur",
        "Procès-verbal de dissolution",
        "Bilan de clôture",
        "Attestations fiscales et parafiscales",
        "Pièces d'identité des associés",
      ],
    },
    ar: {
      title: "حل شركة",
      short: "إغلاق وشطب شركة.",
      items: [
        "القانون الأساسي الساري",
        "محضر الحل",
        "حصيلة الإقفال",
        "الشهادات الضريبية وشبه الضريبية",
        "بطاقات هوية الشركاء",
      ],
    },
  },
  {
    key: "gerance-libre",
    category: "societes",
    fr: {
      title: "Gérance libre de commerce",
      short: "Location-gérance d'un fonds de commerce.",
      items: [
        "Pièces d'identité des parties",
        "Registre du commerce du propriétaire",
        "Contrat de bail commercial du local",
        "Inventaire du fonds de commerce",
        "Conditions financières de la gérance",
      ],
    },
    ar: {
      title: "التسيير الحر للمحل التجاري",
      short: "إيجار تسيير محل تجاري.",
      items: [
        "بطاقات هوية الأطراف",
        "السجل التجاري للمالك",
        "عقد إيجار المحل التجاري",
        "جرد المحل التجاري",
        "الشروط المالية للتسيير",
      ],
    },
  },
  {
    key: "contrat-travail",
    category: "societes",
    fr: {
      title: "Contrat de travail",
      short: "Contrat de travail à formaliser devant notaire.",
      items: [
        "Pièces d'identité de l'employeur et du salarié",
        "Registre du commerce de l'employeur",
        "Description du poste et conditions (salaire, durée, horaires)",
      ],
    },
    ar: {
      title: "عقد العمل",
      short: "عقد عمل يُحرر أمام الموثق.",
      items: [
        "بطاقتا هوية صاحب العمل والأجير",
        "السجل التجاري لصاحب العمل",
        "وصف المنصب والشروط (الأجر، المدة، ساعات العمل)",
      ],
    },
  },
  {
    key: "hypotheque",
    category: "garanties",
    fr: {
      title: "Hypothèque / mainlevée / gage",
      short: "Sûretés réelles sur un bien.",
      items: [
        "Pièces d'identité des parties",
        "Acte de propriété du bien grevé",
        "Contrat de prêt ou document de créance",
        "Montant garanti et durée",
        "Quittance de paiement ou accord du créancier (pour la mainlevée)",
      ],
    },
    ar: {
      title: "الرهن / رفع اليد / الرهن الحيازي",
      short: "ضمانات عينية على مال.",
      items: [
        "بطاقات هوية الأطراف",
        "عقد ملكية المال المرهون",
        "عقد القرض أو وثيقة الدين",
        "المبلغ المضمون والمدة",
        "إيصال الدفع أو موافقة الدائن (لرفع اليد)",
      ],
    },
  },
  {
    key: "certification",
    category: "certifications",
    fr: {
      title: "Certification & vérification documentaire",
      short: "Certification de copie, signature, traduction.",
      items: [
        "Pièce d'identité",
        "Document original à certifier",
        "Traduction officielle (si applicable)",
      ],
    },
    ar: {
      title: "التصديق والتحقق من الوثائق",
      short: "تصديق نسخة، توقيع، ترجمة.",
      items: [
        "بطاقة الهوية",
        "الوثيقة الأصلية المراد تصديقها",
        "ترجمة رسمية (إن وجدت)",
      ],
    },
  },
  {
    key: "expertise-juridique",
    category: "certifications",
    fr: {
      title: "Étude de droit & documentation",
      short: "Expertise juridique et vérification de documents notariés.",
      items: [
        "Pièce d'identité",
        "Dossier à analyser (actes, titres, correspondances)",
        "Description précise de la problématique",
      ],
    },
    ar: {
      title: "دراسة قانونية ووثائقية",
      short: "خبرة قانونية وفحص وثائق موثقة.",
      items: [
        "بطاقة الهوية",
        "الملف المراد دراسته (عقود، سندات، مراسلات)",
        "وصف دقيق للإشكالية",
      ],
    },
  },
];
